<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" role="graphics-symbol">
    <path
      fill="currentColor"
      d="M11.6 1.7c.3.3.4.6.4 1s-.1.7-.4.9l-7.1 7.1h18.1c.4 0 .7.1.9.4.3.3.4.6.4.9 0 .4-.1.7-.4.9-.3.3-.6.4-.9.4h-18l7.1 7.1c.2.3.4.6.4.9 0 .3-.1.7-.4.9-.2.2-.6.4-.9.4s-.7-.1-.9-.4L.4 13c-.3-.3-.4-.6-.4-1s.1-.7.4-.9l9.3-9.3c.3-.2.6-.4.9-.4.4-.1.8.1 1 .3z"
    />
  </svg>
</template>
